export const SITE = {
  name: "LexAIPro",
  legalName: "LexAIPro",
  url: "https://lexaipro.dev",
  locale: "it_IT",
  language: "it-IT",
  description:
    "LexAIPro è la piattaforma di intelligenza artificiale per professionisti legali italiani: ricerca normativa e giurisprudenziale, analisi documentale e redazione assistita di atti e contratti.",
  logo: "https://lexaipro.dev/logo.png",
  ogImage: "https://lexaipro.dev/og-default.jpg",
  email: "beleadcreativestudio@proton.me",
  twitter: "@lexaipro",
} as const;

export const CONTACT_EMAIL = "beleadcreativestudio@proton.me";

export function abs(path: string) {
  if (path.startsWith("http")) return path;
  return `${SITE.url}${path.startsWith("/") ? path : `/${path}`}`;
}
